/**
 * Article layouts index - exports all article layout variants
 * and provides a layout resolver function.
 */
import ArticleLayoutDefault from './ArticleLayoutDefault.mjs';
import ArticleLayoutImmersive from './ArticleLayoutImmersive.mjs';
import ArticleLayoutAnalytical from './ArticleLayoutAnalytical.mjs';
import ArticleLayoutCollaborative from './ArticleLayoutCollaborative.mjs';

// Layout registry - data-aware layouts
const LAYOUTS = {
    'default': ArticleLayoutDefault,
    'immersive': ArticleLayoutImmersive,
    'analytical': ArticleLayoutAnalytical,
    'collaborative': ArticleLayoutCollaborative,
};

/**
 * Get the layout component for a given layout name
 * @param {string} layoutName - Name of the layout
 * @returns {React.Component} - Layout component (defaults to ArticleLayoutDefault)
 */
export function getArticleLayout(layoutName) {
    return LAYOUTS[layoutName] || ArticleLayoutDefault;
}

export {
    ArticleLayoutDefault,
    ArticleLayoutImmersive,
    ArticleLayoutAnalytical,
    ArticleLayoutCollaborative,
    LAYOUTS
};

export default getArticleLayout;
